module.exports = {
      id: "website-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#website-usage",
      toString: function () {
        return this.url;
      }
    }